var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAkitaLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1000 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,33.0806,20.0662)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-118.001,-170.066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.167,374.325L195.638,374.325L176.904,420.7L125,420.7L230.037,175L294.842,175L399.879,420.7L344.9,420.7L326.167,374.325ZM309.888,333.783L260.75,212.471L211.917,333.783L309.888,333.783Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-118.001,-170.066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.335,420.7L547.06,420.7L499.76,362.962C493.619,355.592 489.319,353.442 478.261,353.442L464.131,353.442L464.131,420.704L416.223,420.704L416.223,175L464.136,175L464.136,315.971L477.956,315.971C489.319,315.971 493.619,312.592 500.069,303.687L540.915,248.712L594.66,248.712L535.081,326.721L531.394,331.329C532.623,332.558 534.156,334.092 535.385,335.629L606.335,420.7Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-118.001,-170.066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1044.84,390.908L1044.84,420.7L984.644,420.7L982.802,401.966C968.981,416.708 948.098,425 922.297,425C879.914,425 854.114,402.579 854.114,368.796C854.114,335.625 878.685,313.204 928.747,313.204C945.027,313.204 962.223,315.046 976.044,318.116L976.044,283.716L865.172,283.716L865.172,248.708L1023.65,248.708L1023.65,390.908L1044.84,390.908ZM976.044,349.141L976.044,348.529C962.835,345.15 946.868,344.229 937.347,344.229C908.785,344.229 895.272,351.908 895.272,366.033C895.272,381.696 912.164,387.837 929.056,387.533C954.543,387.529 976.044,375.554 976.044,349.141Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-118.001,-170.066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671.936,175L624.023,175L624.023,221.992L671.936,221.992L671.936,175ZM777.775,175L729.863,175L729.863,248.708L624.032,248.708L624.032,420.7L671.944,420.7L671.944,283.721L729.867,283.721L729.867,356.204C729.867,399.2 751.671,425 797.13,425C810.642,425 825.692,422.237 839.205,418.858L839.205,382.616C830.605,385.379 820.472,387.225 812.484,387.225C789.142,387.225 777.78,372.483 777.78,344.841L777.78,283.721L839.201,283.721L839.201,248.708L777.775,248.708L777.775,175Z",
    style: {
      fill: "white"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkitaLogoLight);
export default __webpack_public_path__ + "static/media/akita_logo_light.0a182e9230161010e29fbbc29c296c07.svg";
export { ForwardRef as ReactComponent };